export const themeClasses = {
  primary: 'bg-white enabled:hover:bg-nebula-500 transition-all text-black',
  secondary:
    'box-border bg-transparent text-white border-2 border-white enabled:hover:bg-white enabled:hover:text-black transition-all',
  tertiary: 'bg-[#2C2C2C] text-white',
  rainbow: 'bg-rainbow text-black ',
  doodlesTV:
    'enabled:bg-doodlesTV hover:opacity-80 text-white disabled:bg-[#242424]',
  retroGlow: 'bg-retroGlow text-black',
  claim:
    'bg-[#05FFA9] text-black disabled:bg-white/20 disabled:text-white/50 !text-sm md:!text-base !font-semibold tracking-[1.6px]',
};

type LoaderThemeType = 'primary' | 'secondary';

export const loaderTheme: Record<string, LoaderThemeType> = {
  primary: 'primary',
  secondary: 'secondary',
  rainbow: 'primary',
};

export const loaderClasses = {
  small: {
    height: 'h-5',
    width: 'w-5',
  },
  medium: {
    height: 'h-6',
    width: 'w-6',
  },
  large: {
    height: 'h-7',
    width: 'w-7',
  },
  xlarge: {
    height: 'h-12',
    width: 'w-12',
  },
};
